import {
  THumanFormStepDefinition,
  TWorkflowDefinition,
  TWorkflowStepDefinition,
  WorkflowStepType,
} from '@commenda/types';

export class WorkflowGraphHelper {
  static collectUpstreamStepIds(
    workflow: TWorkflowDefinition | null,
    stepId: string
  ): Set<string> {
    const sourcesByTarget = new Map<string, string[]>();
    for (const transition of workflow?.stepTransitions ?? []) {
      const sources = sourcesByTarget.get(transition.toStepId);
      if (sources) sources.push(transition.fromStepId);
      else sourcesByTarget.set(transition.toStepId, [transition.fromStepId]);
    }

    const upstream = new Set<string>();
    const queue = [...(sourcesByTarget.get(stepId) ?? [])];
    while (queue.length > 0) {
      const current = queue.shift();
      if (current === undefined || current === stepId || upstream.has(current))
        continue;
      upstream.add(current);
      queue.push(...(sourcesByTarget.get(current) ?? []));
    }

    return upstream;
  }

  static findUpstreamFormSteps(
    workflow: TWorkflowDefinition | null,
    stepId: string
  ): THumanFormStepDefinition[] {
    const upstream = WorkflowGraphHelper.collectUpstreamStepIds(
      workflow,
      stepId
    );

    return (workflow?.steps ?? []).filter(
      (step): step is THumanFormStepDefinition =>
        step.type === WorkflowStepType.HUMAN_FORM && upstream.has(step.id)
    );
  }

  /** Candidate document sources for an ad-hoc e-sign step: the agent steps that always run before it. */
  static findUpstreamAgentSteps(
    workflow: TWorkflowDefinition | null,
    stepId: string
  ): TWorkflowStepDefinition[] {
    const upstream = WorkflowGraphHelper.collectUpstreamStepIds(
      workflow,
      stepId
    );

    return (workflow?.steps ?? []).filter(
      (step) =>
        step.type === WorkflowStepType.SYS_AI_AGENT && upstream.has(step.id)
    );
  }
}
